import React from 'react';
import {FormattedMessage} from 'react-intl';
import {makeStyles} from '@material-ui/core/styles';
import {getImageByAgent} from '../../config/agent';

const BannerImage = getImageByAgent('banners/banner3b.svg');
const useStyles = makeStyles(theme => ({
  banner: {
    '& img': {
      [theme.breakpoints.down(1790)]: {
        left: 'unset',
        right: -23,
        width: 76,
      },
      bottom: 0,
      left: 38,
      position: 'absolute',
      right: 'unset',
      width: 104,
    },
    '& span, b': {
      display: 'block',
    },
    borderRadius: 47,
    boxShadow: '0 0 12px 0 #0000001F',
    color: theme.palette.secondary.mainLight,
    display: 'block',
    margin: '0 20px',
    maxWidth: 480,
    minWidth: 213,
    order: 0,
    position: 'relative',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      display: 'block',
      fontSize: '1em',
      margin: '130px -20px 0 20px',
      padding: '25px 48px 25px 18px',
    },
    [theme.breakpoints.up(14350)]: {margin: '130px auto 0'},
    [theme.breakpoints.up(1790)]: {
      fontSize: '1.125em',
      margin: '80px auto 0',
      padding: '27px 10px 23px 80px',
    },
  },
}));

const BannerStep3b = () => {
  const classes = useStyles();
  return (
    <div className={classes.banner}>
      <img src={BannerImage} alt='' role='presentation'/>
      <FormattedMessage id='insurance_history.banner3_1' tagName='span'/>
      <FormattedMessage id='insurance_history.banner3_2' tagName='b'/>
    </div>
  );
};

export default BannerStep3b;
